import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, Query } from '@angular/fire/firestore';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import firebase from 'firebase/app';
@Component({
  selector: 'app-validaciones',
  templateUrl: './validaciones.component.html',
  styleUrls: ['./validaciones.component.scss']
})
export class ValidacionesComponent implements OnInit {

  private tropasCol: AngularFirestoreCollection<any>;
  public  tropas:    Observable<any>;
  public tropasMap: Map<String,any> = new Map<String,any>();

  private validacionesCol: AngularFirestoreCollection<any>;
  private validaciones: Observable<any>;

  public  allItems: any[];

  public displayedColumns = [
    "solicita", 
    "cedula", "nombres", "telefono", "servicio", 
    "solicitaFecha","aplica","respuesta", "respondeFecha",
    "options"
  ];

  public tropa:string = "";  

  public estado:string = "nuevo";

  public validacion;

  public user:firebase.User;

  constructor(
    private afFirestore: AngularFirestore, 
    private snackBar: MatSnackBar,
    public authService: AuthService){ 
      this.validacion = null;
  }  

  ngOnInit() {
    this.validacionesCol   = this.afFirestore.collection<any>("validaciones", ref => ref.where("estado", "==", "nuevo").limit(100).orderBy("solicitaFecha", "desc") );
    this.validaciones      = this.validacionesCol.snapshotChanges();
    this.tropasCol         = this.afFirestore.collection<any>("tropa");
    this.tropas            = this.tropasCol.valueChanges();
    this.tropas.subscribe(
      (lastTropas)=>{
        lastTropas.forEach(
          (tropa)=>{            
            this.tropasMap.set(tropa.uid, tropa);
          }
        );        
      }
    );
    this.authService.afAuth.user.subscribe(
      (newUser)=>{
        this.user = newUser;
      }
    );  
  }

  private suscription = null;

  public isLoading:boolean = true;  

  ngAfterViewInit(){ 
    this.isLoading = true;
    if( this.suscription != null ){
      this.suscription.unsubscribe();
    }   
    this.suscription = this.validaciones
      .subscribe(
        lastVals => {                     
          console.log("Data length: "+lastVals.length);
          this.allItems = lastVals.map(
            (validacion:any)=>{   
              console.table(validacion);           
              const uid = validacion.payload.doc.id;              
              return {
                uid,
                ...validacion.payload.doc.data()
              };
            }
          );          
          this.isLoading = false;          
        }
      );
  }

  trackByUid(index, item) {
    return item.uid;
  }

  applyFilter() {       
    this.isLoading = true;   
    this.validacionesCol = this.afFirestore.collection<any>(
      "validaciones", 
      ref => {
        let ref2:Query = ref;
        if( this.tropa !== undefined && this.tropa !== "" ){
          console.log("cedula :: "+this.tropa);
          ref2 = ref2.where("reportaCedula", "==", this.tropa);          
        }
        if(  this.estado != undefined && this.estado !== "" ){
          console.log("estado :: "+this.estado);
          ref2 = ref2.where("estado", "==", this.estado);
        }
        ref2 = ref2.limit(100);
        console.log("ordering by date ");
        return ref2.orderBy("solicitaFecha", "desc");
      } 
    );            
    this.validaciones = this.validacionesCol.snapshotChanges();
    this.ngAfterViewInit();    
  }  

  showUpdate(validacion){
    this.validacion = {
      ...validacion
    };
  }

  showList(){
    this.validacion = null;
  }

  update(){
    this.validacionesCol
      .doc(this.validacion.uid)
      .ref
      .set(
        {
          "resuelve": this.user.uid,
          "resuelveNombre": this.user.displayName,
          "resuelveFecha": new Date(),
          "respuesta": this.validacion.respuesta,
          "estado": "resuelto"
        },
        {merge: true}
      )
      .then(
        ()=>{
          this.showList();
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado actualizando la validacion","Entiendo",{duration: 2000});
        }
      ); 
  }

}
